// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const useResizeHeightListener = require('client-v2/logged-out-landing/containers/top-call-to-action/hooks/resize-height')
// Experiment imports
const TopCallToActionSplitLeading = require('./components/split-leading')
const TopCallToActionSplitTrailing = require('./components/split-trailing-smart')

const bem = BemEntity('TopCallToActionExperimentB')

function TopCallToActionExperimentB(props) {
  return tag('div', {
    ref: useResizeHeightListener(props.onFoldHeightChange),
    className: bem.block()
  },
    tag(TopCallToActionSplitLeading, {
      className: bem.element('split', 'leading'),
      forwardedRef: props.forwardedRef
    }),
    tag(TopCallToActionSplitTrailing, {
      className: bem.element('split', 'trailing')
    })
  )
}

module.exports = TopCallToActionExperimentB
